import { FileItem } from '../../../types'
import { IInputNode, QuestionNode } from '../../../actionCard'

export class FileQuestionNode extends QuestionNode implements IInputNode<FileItem[] | undefined> {
  public override getValue(): FileItem[] | undefined {
    const fileItems = getUploadedFileItems.call(this)
    if (fileItems.length <= 0) {
      return
    }
    return fileItems
  }

  public override setValue(value?: FileItem[]): void {
    throw new Error('Set value is not supported for File node')
  }

  public override getStringValue(): string {
    const value = this.getValue()
    return value && value.length > 0 ? JSON.stringify(value) : ''
  }

  public override setStringValue(value?: string): void {
    throw new Error('Set string value is not supported for File node')
  }

  public override stringifyValue(): string {
    const fileItems = getUploadedFileItems.call(this)
    if (fileItems.length <= 0) {
      return ''
    }

    return fileItems.map(x => x.name).join('; ')
  }

  public override isInputEmpty(): boolean {
    return getUploadedFileItems.call(this).length <= 0
  }
}

function getUploadedFileItems(this: FileQuestionNode): FileItem[] {
  return getAllFileItems.call(this).filter(x => !x.error && x.id > 0)
}

function getAllFileItems(this: FileQuestionNode): FileItem[] {
  return (this.data.value ?? []) as FileItem[]
}
